import {Preferences} from "@capacitor/preferences";

export default class LocalStorage {

    static async getItem(key: string): Promise<string | null> {
        const value = await Preferences.get({key: key});
        return value.value;
    }

    static async setItem(key: string, value: string): Promise<void> {
        await Preferences.set({key: key, value: value});
    }

    static async removeItem(key: string): Promise<void> {
        await Preferences.remove({key: key});
    }

    static async clear(): Promise<void> {
        await Preferences.clear();
    }

    static async keys(): Promise<string[]> {
        const keys = await Preferences.keys();
        return keys.keys;
    }
}